export default __webpack_public_path__ + "static/media/android-s3-cn.97417fbc.webp";